import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import nl from "src/locale/nl";
import en from "src/locale/en";

const tenants = {
	getjobsdone: {
		name: "GetJobsDone",
		slug: "getjobsdone",
		code: "GJD",
	},
	getcrewdone: {
		name: "GetCrewDone",
		slug: "getcrewdone",
		code: "GCD",
	},
};

let tenant = tenants.getjobsdone;
if (window.location.host.includes("getcrewdone")) {
	tenant = tenants.getcrewdone;
}

const resources = {
	nl,
	en,
};

i18n.use(initReactI18next).init({
	resources,
	lng: "nl",
	interpolation: {
		escapeValue: false,
		defaultVariables: {
			tenant: tenant,
		},
	},
	react: {
		transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p", "u"],
		useSuspense: false,
	},
	returnNull: false,
});

export default i18n;
